
import React,{useEffect, useState} from 'react'
import { BsFillArchiveFill } from 'react-icons/bs'
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip , Legend, ResponsiveContainer, AreaChart, Area } from 'recharts';
import {  Grid } from "@mui/material";
import { FiUsers, FiCheckCircle, FiHome, FiSearch } from "react-icons/fi";
import { Box, Button, Menu, MenuItem, TableBody, TablePagination, Typography, Divider ,  useScrollTrigger } from '@mui/material';
import { Navbar, Container, Nav, NavDropdown,Dropdown } from 'react-bootstrap';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Paper from "@mui/material/Paper";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { FaEdit, FaMapMarkerAlt, FaMarker, FaUserCircle, FaTrash, FaCheck, FaEye, FaPhone } from 'react-icons/fa';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Fade from '@mui/material/Fade';
import axios from 'axios';
import {
  EmailShareButton,
  FacebookShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  WhatsappIcon,
} from 'react-share';
import LeadManagementPopup from './LeadManagementPopup';


function AdminDashboard() {

  const [id, setId] = React.useState();
  // const [date, setDate] = React.useState()

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open2 = Boolean(anchorEl);

  const handleClick = (event) => {
      setAnchorEl(event);
  };
  const handleClose2 = () => {
      setAnchorEl(null);
  };


  const [projectName, setProjectName] = useState("");
  const [ttowerno, setTowardsTowerNumber] = useState("");
  
  const [responset, setResponset] = useState([]);
  
  const get_floor = () => {
    axios
      .post("https://buildfastvapi.emedha.in/project/api/v1/towers-getall")
      .then((res) => {
        if (res.data.status === 200) {
          setResponset(res.data.data);
          console.log(res.data.data);
        }
      });
  };
  
  React.useEffect(() => {
  
    get_floor();
  
  }, []);


  const [response4, setResponse4] = React.useState([]);

  console.log(response4)

  // https://buildfastvapi.emedha.in/project/api/v1/blockwise-floor

  const get_floors = (ttowerno) => {
    axios
      .post(
        "https://buildfastvapi.emedha.in/project/api/v1/blockwise-floor",
        {
          value1: ttowerno,
        }
      )
      .then((res) => {
        setResponse4(res.data);
        // setTower(value1);
        //select_floor();
      });
  };




  const text = sessionStorage.getItem('user_name')



  const PrName = sessionStorage.getItem("ProjectName");
  console.log(PrName)

  const text1 = sessionStorage.getItem("emailExcutive");
  const PrName1 = sessionStorage.getItem("ProjectName");

  console.log(text)
  const [data, setData] = React.useState([])

  const[tcont, setTcount] = React.useState('')
  localStorage.setItem('managerCount',tcont.totalRecords)
  const[closedCount,setClosedCount]=React.useState('')

  React.useEffect(() => {
      // POST request with text and PrName
      axios.post('https://buildfastvapi.emedha.in/api/v1/managerleadname', {
        projectName: PrName,
      })
      .then(res => {
        console.log(res.data);
        setData(res.data);
      })
      .catch(err => {
        console.error(err);
      });
    
      // GET request with text and PrName
      axios.get(`https://buildfastvapi.emedha.in/api/v1/managerleadcount?projectName=${PrName}`)
      .then(res => {
        console.log(res.data);
        setTcount(res.data);
      })
      .catch(err => {
        console.error(err);
      });
    }, []);

    React.useEffect(() => {
      // POST request with text and PrName
      axios.post('https://buildfastvapi.emedha.in/api/v1/closedamanagerleadname', {

        projectName: PrName
      })
      .then(res => {
        console.log(res.data);
        setData(res.data);
      })
      .catch(err => {
        console.error(err);
      });
    
      // GET request with text and PrName
      axios.get(`https://buildfastvapi.emedha.in/api/v1/managerleadcountclosed?projectName=${PrName1}`)
      .then(res => {
        console.log(res.data);
        setClosedCount(res.data);
      })
      .catch(err => {
        console.error(err);
      });
    }, []);




    const [popupOpen, setPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState([]);
    const [selectedChannelId, setSelectedChannelId] = useState(null);
  

  
    const handleRowClick = (channelId) => {
      setSelectedChannelId(channelId);
      axios.get(`https://buildfastvapi.emedha.in/api/v1/leads-cp?channelId=${channelId}`)
        .then((response) => {
          setPopupData(response.data.data);
          setPopupOpen(true);
        })
        .catch((error) => {
          setError('Failed to fetch leads');
        });
    };
  
    const [selectedFloor, setSelectedFloor] = useState('');

    const handleFloorChange =async (e) => {
      const floor = e.target.value;
      setSelectedFloor(floor);

    }


    // https://buildfastvapi.emedha.in/api/v1/api/project-details?ProjectName=${PrName}&TowerNumber=${ttowerno}&floor=${selectedFloor}
    // http://localhost:3002/api/project-details?ProjectName=${PrName}&TowerNumber=${ttowerno}&floor=${selectedFloor}

const [fetchedData, setFetchedData] = useState([]); // Initialize with an empty array

const fetchData = async () => {
try {
  const response = await fetch(`https://buildfastvapi.emedha.in/api/v1/api/project-details?ProjectName=${PrName}&TowerNumber=${ttowerno}&floor=${selectedFloor}`);
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  const data = await response.json();
  setFetchedData(data); // Update state with fetched data
} catch (error) {
  console.error('Error fetching data:', error);
  // Handle error (e.g., show error message)
}
};

useEffect(() => {
get_floors(ttowerno)
if (ttowerno && PrName && selectedFloor) {
  fetchData();
}
}, [ttowerno, PrName,selectedFloor]); // Dependencies for useEffect

useEffect(() => {
console.log(fetchedData); // Log fetchedData whenever it changes
}, [fetchedData]); // Run this effect whenever fetchedData changes



const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);



const startIndex = page * rowsPerPage;
const endIndex = startIndex + rowsPerPage;



const handleChangePage = (event, newPage) => {
setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
setRowsPerPage(parseInt(event.target.value, 10));
setPage(0);
};


const [open, setOpen] = useState(false);
const [selectedUnit, setSelectedUnit] = useState(null);

const handleOpen = (unit) => {
  setSelectedUnit(unit);
  setOpen(true);
};

const handleClose = () => {
  setOpen(false);
};


const [filterInput, setFilterInput] = useState('');
const [filteredData, setFilteredData] = useState(fetchedData);

React.useEffect(() => {
  setFilteredData(fetchedData);
  updateAvailableUnitsCount(ttowerno);
}, [fetchedData]);


const handleFilterInputChange = (event) => {
  const value = event.target.value.toLowerCase();
  setFilterInput(value);
  const filtered = fetchedData.filter(
    (item) =>
      item.Facing.toLowerCase().includes(value) ||
      item.unitsizeNum.toLowerCase().includes(value) ||
      item.unit_name.toLowerCase().includes(value)
  );
  setFilteredData(filtered);
  setPage(0); // Reset page when applying filters
};


const [availableUnitsCount, setAvailableUnitsCount] = useState(0);


const updateAvailableUnitsCount = (tower) => {
  const filteredUnits = fetchedData.filter(item => item.tower === tower && item.status === 'Available');
  setAvailableUnitsCount(filteredUnits.length);
};



const [dataCp, setDataCp] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);

useEffect(() => {
  // Fetch data from the API
  axios.get('https://buildfastvapi.emedha.in/api/v1/channel-partners')
    .then((response) => {
      setDataCp(response.data.data);
      setLoading(false);
    })
    .catch((error) => {
      setError('Failed to fetch data');
      setLoading(false);
    });
}, []);

if (loading) return <Typography variant="h6">Loading...</Typography>;
if (error) return <Typography variant="h6" color="error">{error}</Typography>;

 const StatCard = ({ title, value, icon, iconBg, iconColor }) => (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2.5, md: 3 }, // Slightly tighter padding on mobile phones
        borderRadius: "16px",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.02)",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": { 
          transform: "translateY(-4px)", // Gentle lift effect on hover
          boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.05)" 
        }
      }}
    >
      <Box>
        <Typography 
          sx={{ 
            color: "#A3AED0", 
            fontSize: "12px", 
            fontWeight: "700", 
            textTransform: "uppercase", 
            letterSpacing: "0.5px",
            mb: 1 
          }}
        >
          {title}
        </Typography>
        <Typography 
          sx={{ 
            color: "#1B2559", 
            fontSize: { xs: "24px", md: "28px" }, 
            fontWeight: "800",
            lineHeight: 1
          }}
        >
          {value || 0} {/* Safe fallback to 0 if data hasn't loaded yet */}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "56px", 
          height: "56px", 
          borderRadius: "50%",
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center",
          backgroundColor: iconBg, 
          color: iconColor
        }}
      >
        {icon}
      </Box>
    </Paper>
  );

  const getStatusBadge = (status) => {
  let bgColor, textColor;
  switch (status) {
    case "Booked":
      bgColor = "#FEF2F2"; // Soft Red
      textColor = "#DC2626";
      break;
    case "Blocked":
      bgColor = "#F8FAFC"; // Soft Slate/Gray
      textColor = "#64748B";
      break;
    default: // Available/Green
      bgColor = "#F0FDF4"; 
      textColor = "#10B981";
  }

  return (
    <Box
      sx={{
        backgroundColor: bgColor,
        color: textColor,
        fontWeight: "700",
        fontSize: "12px",
        padding: "4px 12px",
        borderRadius: "20px",
        display: "inline-block",
      }}
    >
      {status}
    </Box>
  );
};


  return (
      <>
      <sidebar>
          
      </sidebar>
      <main>
          

          {/* <div className='main-cards'>
              <div className='card-box d-flex flex-column justify-content-center' style={{backgroundColor:'#8a0404',color: "white",height:'135px' }}>
                  <div className='card-inner ' >
                      <h3>No.Of Leads</h3>
                      <BsFillArchiveFill className="card-icon" />
                      <h6>{tcont.totalRecords}</h6>
                  </div>
              </div>
              <div className='card-box d-flex flex-column justify-content-center' style={{backgroundColor:'#d2be79',color: "white" }}>
                  <div className='card-inner text-center'>
                      <h3>No.Of Leads Closed </h3>
                      <BsFillArchiveFill className="card-icon" />
                      <h6>{closedCount.totalRecords}</h6>

                  </div>
              </div>
              <div className='card-box d-flex flex-column justify-content-center' style={{backgroundColor:'#d35050',color: "white" }}>
                  <div className='card-inner text-center'>
                      <h3>No.Units Available </h3>
                      <BsFillArchiveFill className="card-icon" />
                      <h6>{availableUnitsCount}</h6>

                  </div>
                  </div>
          </div> */}

          <Box sx={{ width: "100%", mb: 4 }}>
      <Grid container spacing={3}>
        
        {/* Card 1: Total Leads */}
        <Grid item xs={12} sm={4}>
          <StatCard 
            title="Total Leads" 
            value={tcont?.totalRecords} 
            icon={<FiUsers size={24} />} 
            iconBg="#F4F7FE" // Soft Blue/Purple background
            iconColor="#4318ff" // Deep Premium Purple icon
          />
        </Grid>

        {/* Card 2: Leads Closed */}
        <Grid item xs={12} sm={4}>
          <StatCard 
            title="Leads Closed" 
            value={closedCount?.totalRecords} 
            icon={<FiCheckCircle size={24} />} 
            iconBg="#F0FDF4" // Soft Green background
            iconColor="#10B981" // Emerald Green icon
          />
        </Grid>

        {/* Card 3: Units Available */}
        <Grid item xs={12} sm={4}>
          <StatCard 
            title="Units Available" 
            value={availableUnitsCount} 
            icon={<FiHome size={24} />} 
            iconBg="#FFFBEB" // Soft Amber background
            iconColor="#F59E0B" // Deep Amber icon
          />
        </Grid>

      </Grid>
    </Box>

     
        {/* <Typography style={{ marginBottom: 3, marginLeft: 15.5, fontSize: 18, color: 'gray', fontWeight: '500' }}>Search Filter</Typography> */}
      {/* <div className='d-flex flex-row align-items-center p-2'>
      <div>
        <input
          value={filterInput}
          onChange={handleFilterInputChange}
          style={{
            height: '2.3rem',
            color: 'gray',
            borderRadius: '0.3rem',
            outline: 'none',
            width: '15rem',
            border: '0.7px solid lightgray',
          }}
          placeholder="Search...."
        />
      </div>
        <Form.Group as={Col} md="3" controlId="validationCustom01" className='mr-2 p-2'>
                    <Typography style={{ color: "gray", fontSize: 13 }}>
                      ProjectName
                    </Typography>
                    <Form.Select
                      required
                      onChange={(e) => setProjectName(e.target.value)}
                      type="text"
                      style={{ padding: "0.42rem", marginBottom: 14 }}
                    >
                      <option>Select Project</option>
                      <option>{PrName}</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      Please Enter Valid Towards Flat Number
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="3" controlId="validationCustom01" >
                    <Typography style={{ color: "gray", fontSize: 13 }}>
                      Tower{" "}
                    </Typography>
                    <Form.Select
                      required
                      value={ttowerno}
                      onChange={(e) => setTowardsTowerNumber(e.target.value)}
                      type="text"
                      style={{ padding: "0.42rem", marginBottom: 14 }}
                    >
                      <option>Select Tower </option>
                      {responset
                        .filter((item) => item.Towers.startsWith(projectName)) // Filter towers that start with the project name
                        .map((item) => (
                          <option>{item.Towers}</option>
                        ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      Please Enter Valid Towards Tower Number
                    </Form.Control.Feedback>
                  </Form.Group>
                  
                  <Form.Group as={Col} md="3" controlId="validationCustom01" className='mr-2 p-2'>
                  <Typography style={{ color: "gray", fontSize: 13 }}>
                    Floor
                  </Typography>
                  <Form.Select
                    required
                  onChange={handleFloorChange}
                    style={{ padding: "0.42rem", marginBottom: 14 }}
                  >
                    <option>Select Floor</option>
                    {[
                      ...new Set(response4.map((data) => data.floor.trim())),
                    ].map((floor, index) => (
                      <option key={index}>{floor}</option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Please Enter project name
                  </Form.Control.Feedback>
                </Form.Group>


                  </div> */}

      <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // Stacks vertically on phones, side-by-side on desktop
    alignItems: { xs: "stretch", md: "flex-end" }, // Aligns the bottoms of the inputs perfectly on desktop
    gap: "16px",
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #E0E5F2",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.02)",
    width: "100%",
    boxSizing: "border-box",
    mb: 4, // Adds breathing room below the filter section
  }}
>
  {/* --- 1. Global Search Filter --- */}
  <Box sx={{ flex: 1, minWidth: { xs: "100%", md: "220px" } }}>
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Search Details
    </Typography>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "45px", // Standard premium input height
        backgroundColor: "#F4F7FE",
        borderRadius: "8px",
        padding: "0 16px",
        border: "1px solid transparent",
        transition: "all 0.2s ease",
        "&:focus-within": {
          border: "1px solid #4318ff", // Premium purple glow on focus
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 12px rgba(67, 24, 255, 0.05)",
        },
      }}
    >
      <FiSearch style={{ color: "#A3AED0", fontSize: "18px", marginRight: "12px" }} />
      <input
        value={filterInput}
        onChange={handleFilterInputChange}
        placeholder="Search..."
        style={{
          width: "100%",
          border: "none",
          outline: "none",
          backgroundColor: "transparent",
          fontSize: "14px",
          color: "#2B3674",
          fontWeight: "500",
        }}
      />
    </Box>
  </Box>

  {/* --- 2. Project Name Dropdown --- */}
  <Box sx={{ flex: 1, minWidth: { xs: "100%", md: "200px" } }}>
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Project Name
    </Typography>
    <select
      required
      onChange={(e) => setProjectName(e.target.value)}
      style={{
        width: "100%",
        height: "45px",
        padding: "0 16px",
        fontSize: "14px",
        color: "#2B3674",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        borderRadius: "8px",
        outline: "none",
        cursor: "pointer",
        fontWeight: "600",
        transition: "all 0.2s ease",
      }}
      onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
      onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
    >
      <option value="">Select Project</option>
      <option value={PrName}>{PrName}</option>
    </select>
  </Box>

  {/* --- 3. Tower Dropdown --- */}
  <Box sx={{ flex: 1, minWidth: { xs: "100%", md: "200px" } }}>
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Tower
    </Typography>
    <select
      required
      value={ttowerno}
      onChange={(e) => setTowardsTowerNumber(e.target.value)}
      style={{
        width: "100%",
        height: "45px",
        padding: "0 16px",
        fontSize: "14px",
        color: "#2B3674",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        borderRadius: "8px",
        outline: "none",
        cursor: "pointer",
        fontWeight: "600",
        transition: "all 0.2s ease",
      }}
      onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
      onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
    >
      <option value="">Select Tower</option>
      {responset
        .filter((item) => item.Towers.startsWith(projectName))
        .map((item, index) => (
          <option key={index} value={item.Towers}>
            {item.Towers}
          </option>
        ))}
    </select>
  </Box>

  {/* --- 4. Floor Dropdown --- */}
  <Box sx={{ flex: 1, minWidth: { xs: "100%", md: "200px" } }}>
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Floor
    </Typography>
    <select
      required
      onChange={handleFloorChange}
      style={{
        width: "100%",
        height: "45px",
        padding: "0 16px",
        fontSize: "14px",
        color: "#2B3674",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        borderRadius: "8px",
        outline: "none",
        cursor: "pointer",
        fontWeight: "600",
        transition: "all 0.2s ease",
      }}
      onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
      onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
    >
      <option value="">Select Floor</option>
      {[...new Set(response4.map((data) => data.floor.trim()))].map((floor, index) => (
        <option key={index} value={floor}>
          {floor}
        </option>
      ))}
    </select>
  </Box>
</Box>


        
<Paper 
  elevation={0} 
  sx={{ 
    width: "100%", 
    borderRadius: "12px", 
    border: "1px solid #E0E5F2", 
    backgroundColor: "#ffffff",
    boxShadow: "0px 4px 15px rgba(0,0,0,0.02)",
    overflow: "hidden" // Keeps rounded corners clean
  }}
>
  <TableContainer 
    sx={{ 
      maxHeight: "600px", // Optional: Keeps table height manageable
      overflowX: "auto", 
      '&::-webkit-scrollbar': { height: '6px', width: '6px' },
      '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
    }}
  >
    <Table sx={{ minWidth: 800 }} stickyHeader aria-label="premium real estate table">
      
      {/* PREMIUM HEADER */}
      <TableHead>
        <TableRow>
          {["Floor", "Unit Name", "Status", "Unit Size", "Facing", "Corner", "Total Value"].map((headCell, index) => (
            <TableCell 
              key={index} 
              align="start" 
              sx={{ 
                background: "linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)", 
                color: "#ffffff", 
                fontWeight: "700", 
                fontSize: "13px", 
                padding: "16px",
                borderBottom: "1px solid #E0E5F2",
                whiteSpace: "nowrap", 
                zIndex: 2 
              }}
            >
              {headCell}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      {/* TABLE BODY */}
      <TableBody>
        {filteredData.slice(startIndex, endIndex).map((row, index) => {
          // console.log(`Row ${index + 1} - Mortgage:`, row.Mortgage);
          return (
            <TableRow 
              hover 
              key={index}
              sx={{
                // Applies a premium subtle tint if Mortgage === 1
                backgroundColor: row.Mortgage === 1 ? "#F8FAFC" : "inherit",
                transition: "background-color 0.2s"
              }}
            >
              <TableCell align="start" sx={{ fontSize: "13px", fontWeight: "700", color: "#2B3674", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                {row.floor}
              </TableCell>
              <TableCell align="start" sx={{ fontSize: "13px", fontWeight: "500", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                {row.unit_name}
              </TableCell>
              <TableCell align="start" sx={{ padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                {getStatusBadge(row.status)}
              </TableCell>
              <TableCell align="start" sx={{ fontSize: "13px", fontWeight: "500", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                {row.unitsizeNum}
              </TableCell>
              <TableCell align="start" sx={{ fontSize: "13px", fontWeight: "500", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                {row.Facing}
              </TableCell>
              <TableCell align="start" sx={{ fontSize: "13px", fontWeight: "500", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                {row.cornor}
              </TableCell>
              <TableCell 
                align="start" 
                onClick={() => handleOpen(row)}
                sx={{ 
                  fontSize: "13px", 
                  fontWeight: "700", 
                  color: "#4318ff", // Premium purple link
                  padding: "14px 16px", 
                  borderBottom: "1px solid #E0E5F2", 
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  "&:hover": { color: "#6d28d9", textDecoration: "underline" }
                }}
              >
                {row.totalvalue}
              </TableCell>
            </TableRow>
          );
        })}

        {/* Empty State Fallback */}
        {filteredData.length === 0 && (
          <TableRow>
            <TableCell colSpan={7} align="center" sx={{ padding: "40px" }}>
              <Typography sx={{ color: "#A3AED0", fontWeight: "600", fontSize: "14px" }}>
                No units found matching your criteria.
              </Typography>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>

  {/* INTEGRATED PAGINATION */}
  <TablePagination
    rowsPerPageOptions={[10, 25, 50]}
    component="div"
    count={fetchedData.length}
    rowsPerPage={rowsPerPage}
    page={page}
    onPageChange={handleChangePage}
    onRowsPerPageChange={handleChangeRowsPerPage}
    sx={{ 
      color: "#707eae", 
      fontWeight: "600", 
      borderTop: "1px solid #E0E5F2" // Clean separation from the table
    }}
  />

  {/* --- PREMIUM POPUP DIALOG FOR UNIT DETAILS --- */}
  <Dialog 
    open={open} 
    onClose={handleClose} 
    maxWidth="sm" 
    fullWidth
    PaperProps={{
      sx: { borderRadius: "16px", padding: "10px" } // Rounded corners for modern feel
    }}
  >
    <DialogTitle sx={{ color: "#1B2559", fontWeight: "800", fontSize: "22px", pb: 1 }}>
      {selectedUnit ? `${selectedUnit.unit_name} Overview` : "Unit Details"}
    </DialogTitle>
    <Divider sx={{ mx: 3, mb: 2 }} />
    
    <DialogContent>
      <Grid container spacing={2}>
        {/* Dynamic Detail Generator to keep your code incredibly clean */}
        {[
          { label: "Facing Amount", value: selectedUnit?.facingAmount },
          { label: "Corner Amount", value: selectedUnit?.cornerAmount },
          { label: "Base Price", value: selectedUnit?.BasePrice },
          { label: "Advance Maintenance", value: selectedUnit?.advMaitanceAmt },
          { label: "Car Parking Amount", value: selectedUnit?.carpousAmt }, 
          { label: "Caution (Non-Refundable)", value: selectedUnit?.cautionNonRefAmt },
          { label: "Caution (Refundable)", value: selectedUnit?.cautionRefAmt },
          { label: "Clubhouse Amount", value: selectedUnit?.clubHouseAmt },
          { label: "Water & Electricity", value: selectedUnit?.waterElectricityAmt },
          { label: "Floor Rise Amount", value: selectedUnit?.floorRiseAmount },
        ].map((item, idx) => (
          <Grid item xs={12} sm={6} key={idx}>
            <Box sx={{ p: 1.5, backgroundColor: "#F4F7FE", borderRadius: "8px", height: "100%" }}>
              <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase" }}>
                {item.label}
              </Typography>
              <Typography sx={{ color: "#2B3674", fontSize: "14px", fontWeight: "700", mt: 0.5 }}>
                {item.value || "—"}
              </Typography>
            </Box>
          </Grid>
        ))}

        {/* Highlighted Total Value Box */}
        <Grid item xs={12}>
          <Box sx={{ p: 2, backgroundColor: "#F0FDF4", borderRadius: "8px", border: "1px dashed #10B981", display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
            <Typography sx={{ color: "#059669", fontSize: "14px", fontWeight: "800", textTransform: "uppercase" }}>
              Total Value
            </Typography>
            <Typography sx={{ color: "#059669", fontSize: "20px", fontWeight: "800" }}>
              {selectedUnit?.totalvalue || "—"}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </DialogContent>

    <DialogActions sx={{ padding: "16px 24px", justifyContent: "space-between", alignItems: "center" }}>
      {/* Share Buttons Container */}
      <Box sx={{ display: "flex", gap: "16px" }}>
        <EmailShareButton
          subject={`Details of ${selectedUnit ? selectedUnit.unit_name : ''}`}
          body={`Details of ${selectedUnit ? selectedUnit.unit_name : ''}:\n\n` +
            `Facing Amount: ${selectedUnit?.facingAmount || ''}\n` +
            `Corner Amount: ${selectedUnit?.cornerAmount || ''}\n` +
            `Base Price: ${selectedUnit?.BasePrice || ''}\n` +
            `Advance Maintenance Amount: ${selectedUnit?.advMaitanceAmt || ''}\n` +
            `Car Parking Amount: ${selectedUnit?.carpousAmt || ''}\n` +
            `Caution Non Refundable Amount: ${selectedUnit?.cautionNonRefAmt || ''}\n` +
            `Caution Refundable Amount: ${selectedUnit?.cautionRefAmt || ''}\n` +
            `Clubhouse Amount: ${selectedUnit?.clubHouseAmt || ''}\n` +
            `Water Electricity Amount: ${selectedUnit?.waterElectricityAmt || ''}\n` +
            `Floor Rise Amount: ${selectedUnit?.floorRiseAmount || ''}\n` +
            `Total Value: ${selectedUnit?.totalvalue || ''}\n`}
        >
          <EmailIcon size={36} round />
        </EmailShareButton>

        <WhatsappShareButton
          title={`Details of ${selectedUnit ? selectedUnit.unit_name : ''}`}
          url={window.location.href}
        >
          <WhatsappIcon size={36} round />
        </WhatsappShareButton>
      </Box>

      {/* Close Button */}
      <Button 
        onClick={handleClose} 
        sx={{ 
          backgroundColor: "#F4F7FE", 
          color: "#4318ff", 
          fontWeight: "700", 
          textTransform: "none", 
          borderRadius: "8px", 
          padding: "8px 24px",
          transition: "all 0.2s",
          "&:hover": { backgroundColor: "#E9EDF7", transform: "translateY(-1px)" }
        }}
      >
        Close
      </Button>
    </DialogActions>
  </Dialog>
</Paper>

         
      </main>

      <Typography variant="h6" style={{marginTop:30,color:'blue'}}>Channel Partner</Typography>

      <TableContainer component={Paper} >
      
    <Table>
      <TableHead> 
        <TableRow>
          <TableCell align="start" style={{ minWidth: 160, fontSize: 14, fontWeight: "600" }}>S.NO</TableCell>
          <TableCell align="start" style={{ minWidth: 160, fontSize: 14, fontWeight: "600" }}>Name</TableCell>
          <TableCell align="start" style={{ minWidth: 160, fontSize: 14, fontWeight: "600" }}>Mobile</TableCell>
          <TableCell align="start" style={{ minWidth: 160, fontSize: 14, fontWeight: "600" }}>Project Name</TableCell>

          <TableCell align="start" style={{ minWidth: 160, fontSize: 14, fontWeight: "600" }}>Channel ID</TableCell>
      
          <TableCell align="start" style={{ minWidth: 160, fontSize: 14, fontWeight: "600" }}>RERANO</TableCell>
   
        </TableRow>
      </TableHead>
      <TableBody>
        {dataCp.filter((row=>row.projectName===PrName)).map((row,index) => (
          <TableRow key={row.id}>
            <TableCell>{index + 1}</TableCell>
            <TableCell>{row.name}</TableCell>
            <TableCell>{row.mobile}</TableCell>
            <TableCell>{row.projectName}</TableCell>
            <TableCell key={row.id} onClick={() => handleRowClick(row.channelId)}>{row.channelId}</TableCell>
    
            <TableCell>{row.rerano}</TableCell>
            
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>

  {popupOpen && popupData && (
    <>
    <Typography variant="h6" style={{ marginTop: 30, color: 'blue' }}>Channel Partner Lead Data</Typography>
  <TableContainer component={Paper} style={{marginTop:'20px'}}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>Project</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Sales Executive</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {popupData.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.mobile}</TableCell>
                <TableCell>{row.ProjectName}</TableCell>
                <TableCell>{row.location}</TableCell>
                <TableCell>{row.salesExecutive}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </>
  )}

    {/* <LeadManagementPopup
      open={popupOpen}
      onClose={() => setPopupOpen(false)}
      data={popupData}
    />
       */}
      </>
  )
}

export default AdminDashboard;
